import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import Button from 'components/button';
import Checkbox from 'components/checkbox';
import Modal from 'components/modal';

import cross from 'assets/icons/cross-gray.svg';
import dotIcon from 'assets/images/dotsIcon.svg';

import style from './columns-modal.module.scss';

const ColumnModal = ({
  columns,
  setColumns,
  onColumnsReset,
  setChoseColModal,
  choseColModal = false,
}) => {
  const [columnsCopy, setColumnsCopy] = useState([...columns]);
  const [checkAllcolumnsShouldBeDisplayed, setAllColumnsShouldBeDisplayed] =
    useState(false);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) return;

    const items = reorder(
      [...columnsCopy],
      result.source.index,
      result.destination.index
    );
    setColumnsCopy([...items]);
  };

  const checkedAllColumnsHandleEvent = (event) => {
    let _columns = [];

    if (event?.target?.checked) {
      setAllColumnsShouldBeDisplayed(true);
      _columns = columnsCopy?.map((column) => {
        return { ...column, hidden: false };
      });
    } else {
      setAllColumnsShouldBeDisplayed(false);
      _columns = columnsCopy?.map((column) => {
        return { ...column, hidden: true };
      });
    }
    setColumnsCopy(_columns);
  };

  const saveColumnChanges = async () => {
    await setColumns([...columnsCopy]);
    setChoseColModal(false);
  };

  const selectSingleColumn = (value, columnKey) => {
    let _columns = [];
    _columns = columnsCopy?.map((x) => {
      return {
        ...x,
        hidden: x?.key === columnKey ? !value : x?.hidden,
      };
    });

    checkIfAllTheColumnsAreCheckedOrUnChecked(_columns);
    setColumnsCopy(_columns);
  };

  const checkIfAllTheColumnsAreCheckedOrUnChecked = (columns) => {
    const checkedAllColumns = columns?.every(
      (column) => column?.hidden === false
    );
    if (checkedAllColumns) setAllColumnsShouldBeDisplayed(true);
    else setAllColumnsShouldBeDisplayed(false);
  };

  const handleClose = () => setChoseColModal(false);

  useEffect(() => {
    setColumnsCopy([...columns]);
    checkIfAllTheColumnsAreCheckedOrUnChecked(columns);
  }, [columns]);

  useEffect(() => {
    document.body.style.overflow = choseColModal ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [choseColModal]);

  const columnsHidden = [...columnsCopy.map((x) => x.hidden)];
  columnsHidden.pop();
  const isDisabled = !columnsHidden?.includes(false);

  return (
    <div>
      <Modal
        open={choseColModal}
        handleClose={handleClose}
        className={style.mainDiv}
      >
        <div className={style.crossImg}>
          <img src={cross} alt="" onClick={handleClose} />
        </div>
        <span className={style.modalTitle}>Change Columns</span>
        <div className={style.selectAllDiv}>
          <Checkbox
            type="checkbox"
            id="selectAll"
            label="Select All"
            className={style.checkbox1}
            containerClass={style.checkboxClass}
            checked={checkAllcolumnsShouldBeDisplayed}
            handleChange={checkedAllColumnsHandleEvent}
          />
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-id">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={style.upperDiv}
              >
                {columnsCopy?.map((ele, index) => {
                  if (ele?.key !== 'actions') {
                    return (
                      <Draggable
                        key={ele.key}
                        index={index}
                        draggableId={ele.key}
                      >
                        {(provided) => (
                          <div
                            key={ele.key}
                            ref={provided.innerRef}
                            className={style.rowDiv}
                            {...provided.draggableProps}
                          >
                            <Checkbox
                              type="checkbox"
                              id={ele.key}
                              label={ele.name}
                              checked={!ele?.hidden}
                              className={style.checkbox}
                              handleChange={(event) =>
                                selectSingleColumn(
                                  event?.target?.checked,
                                  ele?.key
                                )
                              }
                            />
                            <img {...provided.dragHandleProps} src={dotIcon} />
                          </div>
                        )}
                      </Draggable>
                    );
                  }
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className={style.mainBtnDiv}>
          <Button
            type="button"
            text={'Confirm Changes'}
            disabled={isDisabled}
            btnClass={style.btnClassModal}
            handleClick={saveColumnChanges}
          />
          <Button
            text={'Reset to Default'}
            type="button"
            handleClick={onColumnsReset}
            btnClass={style.colModalCancel}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ColumnModal;
